export default [
  {
    id: 1,
    question: "What is your favorite NBA team?",
    options: ["Golden State Warriors", "Los Angeles Lakers", "Miami Heat"],
  },
  {
    id: 2,
    question: "How much are you willing to pay for an NBA ticket?",
    options: ["$50", "$200", "$1000"],
  },
  {
    id: 3,
    question: "How loud do you get when you watch your team play?",
    options: [
      "I don't express emotions when watching sports",
      "I throw a fist-pump here and there",
      "I will scream and run around the house",
    ],
  },
];
